import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectScope } from '../../components/ProjectScope';
import { Dashboard } from './Dashboard';
import { Events } from './Events';
import { Analysis } from './Analysis';
import { NewAnalysis } from './Analyses';

export function DelayRoutes() {
  return (
    <ProjectScope
      storageKey="munin.delay.project"
      emptyBody="Analisis keterlambatan menggantung pada sebuah proyek dan versi programme-nya. Buat proyek lebih dulu."
    >
      {(projectId) => (
        <Routes>
          <Route path="/" element={<Dashboard projectId={projectId} />} />
          <Route path="/events" element={<Events projectId={projectId} />} />
          <Route path="/new" element={<NewAnalysis projectId={projectId} />} />
          <Route path="/analyses/:id" element={<Analysis projectId={projectId} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </ProjectScope>
  );
}
